import { render, staticRenderFns } from "./AppNoContent.vue?vue&type=template&id=05a3410c&"
import script from "./AppNoContent.vue?vue&type=script&lang=js&"
export * from "./AppNoContent.vue?vue&type=script&lang=js&"
import style0 from "./AppNoContent.vue?vue&type=style&index=0&id=05a3410c&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports